export const asc = 'asc';
export const desc = 'desc';

export type SortingType = typeof asc | typeof desc;
